import { useState } from 'react'

type Input = {
  onExited: () => void
}

/**
 * Drawerの開閉アニメーションを管理するhook
 *
 * マウント時にアニメーション付きで開き、
 * requestClose()でアニメーション付きで閉じる。
 * 閉じるアニメーション完了後にonExitedが呼ばれる。
 */
export const useDrawerAnimation = ({ onExited }: Input) => {
  const [open, setOpen] = useState(true)

  const requestClose = () => {
    setOpen(false)
  }

  const handleExited = () => {
    onExited()
  }

  return {
    open,
    requestClose,
    handleExited,
  }
}
